export const MAIL = "&#099;&#111;&#110;&#116;&#097;&#099;&#116;&#064;&#102;&#108;&#117;&#120;&#105;&#098;&#105;&#108;&#105;&#116;&#121;&#046;&#105;&#111;"